import { EditOutlined } from '@ant-design/icons';
import { Button, Card, Space, Tag, Typography } from 'antd';
import { PERMISSION_ACTIONS, PERMISSION_ROUTES } from 'constants/permissions';
import dayjs from 'dayjs';
import { useUIDispatchContext } from 'providers/UI';
import { FC } from 'react';
import { useParams } from 'react-router-dom';

import { useAppointmentDetail } from 'pages/AppointmentsDetails/AppointmentDetailContext';
import { PaymentDetails, Private } from 'components/shared';

const PaymentInfo: FC = () => {
  // navigation
  const params = useParams();
  // context
  const { toggleModal } = useUIDispatchContext();
  const { appointment } = useAppointmentDetail();

  const adminPayment = appointment?.admin_payment;
  const patientPayment = appointment?.patient_payment_info;

  if (!appointment) {
    return null;
  }

  return (
    <div>
      <Card
        title="Doctor payment"
        extra={
          <Private
            route={PERMISSION_ROUTES.appointments}
            action={PERMISSION_ACTIONS.updatePayment}
          >
            <Button
              icon={<EditOutlined />}
              onClick={() =>
                toggleModal('paymentStatus', true, { id: params?.id })
              }
            />
          </Private>
        }
        style={{ marginBottom: 24 }}
      >
        <Space>
          <Typography.Title level={5} style={{ margin: 0 }}>
            Status:{' '}
          </Typography.Title>
          {adminPayment?.paid ? (
            <Tag color="green">Paid</Tag>
          ) : (
            <Tag color="red">Not Paid</Tag>
          )}
        </Space>
        {!!adminPayment?.paid && !!adminPayment?.payed_at && (
          <div style={{ marginTop: 16 }}>
            <Space>
              <Typography.Title level={5} style={{ margin: 0 }}>
                Payment date:{' '}
              </Typography.Title>
              <Typography.Text>
                {dayjs(adminPayment.payed_at).format('YYYY-MM-DD HH:mm')}
              </Typography.Text>
            </Space>
          </div>
        )}
        <div style={{ marginTop: 16 }}>
          <Typography.Title level={5}>Notes</Typography.Title>
          <Typography.Paragraph>
            {adminPayment?.note || '-'}
          </Typography.Paragraph>
        </div>
      </Card>
      <Card title="Patient payment history">
        <PaymentDetails payments={patientPayment || []} />
      </Card>
    </div>
  );
};

export default PaymentInfo;
